import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostCustomerFeatureFlagsRequest = {
	customerId?: number;
	flags?: string[];
	shardName?: string;
};

export const postCustomerFeatureFlags = createPostEndpoint<PostCustomerFeatureFlagsRequest, void>(
	(request) => `/api/v3/core/customers/${request?.customerId ?? 'current'}/feature-flags`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		requestTransform: (request) => request?.flags,
		skipAuthRefresh: true
	}
);
